<template>
  <div class="yxtbiz-attachment-check hover-bg-primary-1" :class="mode === 'thumbnail' ? 'yxtbiz-attachment-thumbnailMode' : 'yxtbiz-attachment-textMode'">
    <div v-if="mode === 'thumbnail'" class="yxtbiz-attachment-check__thumbnail" :style="{'backgroundImage' : data.fileType === 'picture' ? `url(${data.url})` : (data.viewUrl ? `url(${data.viewUrl})` : null)}" :class="data.viewUrl ? '' : 'yxtbiz-attachment-check__' + fileThumbnail">
      <span class="yxtbiz-attachment-check__delete" v-if="mode === 'thumbnail' && needDelete" @click="handleClose">
        <i class="yxt-icon-close"></i>
      </span>
    </div>
    <div class="yxtbiz-attachment-check__text">
      <span class="yxtbiz-attachment-check__name hover-primary-6" :class="needDetail ? 'hand' : ''" @click="viewDetail">
        <yxt-svg icon-class="attachment" width="14px" height="14px" class="yxtbiz-attachment-check__icon v-mid" :remote-url='mediaPath' v-if="mode === 'text'"/>
        <yxt-tooltip :content="data.name" placement="top" class="yxtbiz-attachment-check__val" open-filter>
          <span>{{ data.name }}</span>
        </yxt-tooltip>
      </span>

      <i class="yxt-icon-download yxtbiz-attachment-check__download hover-primary-6 color-gray-6" v-if="needDownload" @click="handleDownload"></i>
      <i class="yxt-icon-close hover-primary-6 color-gray-6" v-if="mode === 'text' && needDelete" @click="handleClose"></i>
    </div>
  </div>
</template>

<script>
import bizSvg from 'yxt-biz-pc/src/mixins/bizSvg';

export default {
  name: 'YxtbizAttachmentCheck',
  mixins: [bizSvg],
  props: {
    data: {
      type: Object
    },
    mode: {
      type: String,
      default: 'thumbnail'
    },
    needDownload: {
      type: Boolean,
      default: true
    },
    needDelete: {
      type: Boolean,
      default: true
    },
    // 默认
    needDetail: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
    };
  },
  computed: {
    fileThumbnail() {
      let thumbnail;
      switch (this.data.fileType) {
        case 'audio':
          thumbnail = 'audio';
          break;
        case 'pdf':
          thumbnail = 'pdf';
          break;
        case 'ppt':
          thumbnail = 'ppt';
          break;
        case 'video':
          thumbnail = 'video';
          break;
        case 'word':
          thumbnail = 'word';
          break;
        case 'xls':
          thumbnail = 'xls';
          break;
        case 'zip':
          thumbnail = 'zip';
          break;
        case 'picture':
          thumbnail = 'picture';
          break;
        default:
          thumbnail = 'unknow';
          break;
      }
      return thumbnail;
    }
  },
  created() {
  },
  methods: {
    // 删除附件
    handleClose(event) {
      this.$emit('close', event);
    },
    handleDownload() {
      this.$emit('download', this.data.fileId);
    },
    viewDetail() {
      this.$emit('detail');
    }
  }
};
</script>
